import { Backdrop, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleByIdTranscationTotalQuery } from "src/services/transcationService";
import TaxInvoice from "./TaxInvoice";

const ReceiptDownload = () => {
  const { id } = useParams();
  const [receiptData, setReceiptData] = useState<any>();
  const { data, isFetching, isLoading } =
    useGetSingleByIdTranscationTotalQuery(id);

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setReceiptData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  if (isFetching || isLoading) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 py-6 print:bg-white print:py-0">
      <div className="no-print mx-auto mb-3 flex max-w-[860px] justify-end px-4">
        <button
          type="button"
          onClick={() => window.print()}
          className="rounded bg-[#082645] px-4 py-2 text-sm font-medium text-white"
        >
          Print Invoice
        </button>
      </div>
      <TaxInvoice receiptData={receiptData} />
    </div>
  );
};

export default ReceiptDownload;
